import { FC, useEffect, useRef } from 'react';
import classes from './styles.module.css';
import { useCountdownSeconds } from './useCountdownSeconds';
import { Elevation } from '../Elevation';

type CountdownSecondsProps = {
	initialSeconds: number;
	autoRemove?: boolean;
};

const CountdownSeconds: FC<CountdownSecondsProps> = ({ initialSeconds, autoRemove }) => {
	const secondsRef = useRef<HTMLSpanElement>(null);
	const { startCountdown, seconds } = useCountdownSeconds({
		initialSeconds,
		secondsElement: secondsRef,
	});

	useEffect(() => {
		startCountdown();
	}, [startCountdown]);

	if (autoRemove && seconds <= 0) {
		return null;
	}

	return (
		<Elevation className={classes.root}>
			<div className={classes.timeContainer}>
				<span
					ref={secondsRef}
					className={classes.seconds}
				/>
			</div>
		</Elevation>
	);
};

export default CountdownSeconds;
